var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "45px",
    height: "45px",
    viewBox: "0 0 45 45",
    enableBackground: "new 0 0 45 45",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M8,12c0,0.1,0,0.3,0.1,0.4h0.3c1.7-0.1,3.2,1.2,3.3,2.9c0,0,0,0,0,0c0.2,1.5,1,2.9,2.2,3.9 c1,0.8,2.4,1.3,3.7,1.3h0.7c1.7-0.2,3.2-1.1,4.2-2.5c0.5,1.2,0.8,2.4,0.8,3.7v4.1h-7c-1,0-1.8,0.8-1.8,1.8c0,1,0.8,1.8,1.8,1.9H17 l1.7,7.6c0.1,0.2,0.2,0.3,0.4,0.3h10.5c0.2,0,0.3-0.1,0.4-0.3l1.7-7.6h0.7c1-0.1,1.8-0.9,1.8-1.9c0-1-0.8-1.8-1.8-1.8h-7v-4.1 c0-0.4,0-0.9-0.1-1.3c0.2-0.9,0.5-1.7,1-2.4c0.5,0.7,1.3,1.2,2.1,1.4l1.5,0.3c0.7,0,1.4-0.2,2-0.5c1.6-0.8,2.6-2.4,2.6-4.2 c0-1.3,1-2.3,2.2-2.4c0.2,0,0.3-0.1,0.3-0.2c0.1-0.1,0.1-0.2,0-0.3c0,0,0,0,0,0c-1.9-2.9-5.8-3.7-8.7-1.8c-2,1.3-3,3.6-2.8,6 c-0.3,0.5-0.6,1-0.8,1.5c-0.3-1-0.8-1.9-1.4-2.7c-0.1-1.7-0.7-3.3-1.7-4.6c-1.4-1.6-3.3-2.7-5.4-3C12.8,7.2,9.5,9,8,12z M29.4,36.7 H19.2l-1.6-7.3H31L29.4,36.7z M28.7,11C31,9.4,34.2,9.8,36,12c-1.4,0.4-2.3,1.6-2.3,3c0.1,1.5-0.8,3-2.2,3.6c-0.9,0.5-2,0.5-3,0.2 c-1-0.3-1.8-1-2.3-2C25.7,14.6,26.7,12.2,28.7,11z M23.2,16.5v-0.2c0.4,0.8,0.8,1.6,1,2.5c0.1,0.2,0.2,0.3,0.3,0.3 c0.2,0,0.3-0.1,0.4-0.3c0.2-0.6,0.5-1.1,0.8-1.6c-0.5,1-0.9,2-1.2,3.1c0.1,0.4,0.1,0.9,0.1,1.3v4.1H24v-4c0-1.6-0.4-3.1-1-4.5 L23.2,16.5z M16,8.2c2,0.2,3.7,1.2,4.9,2.8c1.2,1.5,1.8,3.4,1.6,5.3c-0.7,1.9-2.4,3.3-4.4,3.5c-1.4,0.2-2.8-0.2-3.8-1.1 c-1.1-0.9-1.8-2.1-2-3.5c-0.2-1.8-1.7-3.2-3.5-3.4C10.3,9.4,13.2,8,16,8.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#C9C9C9",
    points: "17.7,29.5 19.2,36.7 29.4,36.7 31,29.5  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF9705",
    d: "M24,21.7v4h0.7v-4.1c0-0.4,0-0.9-0.1-1.3c0.3-1.1,0.7-2.1,1.2-3.1c-0.3,0.5-0.6,1-0.8,1.6 c-0.1,0.2-0.2,0.3-0.4,0.3c-0.1,0-0.2-0.1-0.3-0.3c-0.2-0.9-0.6-1.7-1-2.5v0.2L23,17.2C23.6,18.7,23.9,20.2,24,21.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#28B557",
    d: "M12.4,15.2c0.2,1.4,0.9,2.6,2,3.5c1,0.9,2.4,1.3,3.8,1.1c2-0.2,3.7-1.6,4.4-3.5c0.2-1.9-0.4-3.8-1.6-5.3 C19.8,9.5,18,8.4,16,8.2c-2.9-0.3-5.7,1.1-7.2,3.6C10.7,12,12.1,13.4,12.4,15.2z M14.9,11c2.5,0.2,4.8,1.3,6.6,3.1 c0.1,0.1,0.1,0.4,0,0.5H21c-1.6-1.7-3.8-2.7-6.1-3c-0.2,0-0.3-0.1-0.3-0.3S14.7,10.9,14.9,11z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#28B557",
    d: "M28.5,18.9c1,0.3,2.1,0.3,3-0.2c1.4-0.6,2.3-2.1,2.2-3.6c0-1.4,0.9-2.6,2.3-3c-1.8-2.2-5-2.7-7.4-1.1 c-2,1.3-2.9,3.6-2.4,5.9C26.7,17.8,27.5,18.5,28.5,18.9z M26.7,15.5c1.5-1.8,3.6-3,5.9-3.4C32.9,12,33,12,33,12.2s-0.1,0.4-0.3,0.4 c-2.1,0.5-4,1.6-5.5,3.2L27,16h-0.2C26.5,15.7,26.5,15.5,26.7,15.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ECECEC",
    d: "M14.9,11.5c2.3,0.3,4.5,1.3,6.1,3h0.5c0.1-0.1,0.1-0.4,0-0.5c-1.8-1.8-4.1-2.9-6.6-3.1 c-0.2-0.1-0.3,0.1-0.3,0.3S14.7,11.5,14.9,11.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ECECEC",
    d: "M27,16l0.3-0.2c1.5-1.6,3.4-2.7,5.5-3.2c0.2,0,0.3-0.2,0.3-0.4S32.9,12,32.7,12c-2.3,0.4-4.4,1.6-5.9,3.4 c-0.2,0.1-0.2,0.3,0,0.5H27z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlant);
export default __webpack_public_path__ + "static/media/plant.9e54246754f1c1dd1b7aac5f4eb51571.svg";
export { ForwardRef as ReactComponent };